module.exports = "\n\n  <div\n\n    [@hideAndShow]=\"show\">\n    <ng-content></ng-content>\n  </div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/generic-filters/generic-filters.component.html
// module id = ./src/app/shared-components/generic-filters/generic-filters.component.html
// module chunks = main